import { createAboutUsDutyStoreDefaultModel } from "./about-us-duty/about-us-duty.store";
import { createAboutUsProfileStoreDefaultModel } from "./about-us-profile/about-us-profile.store";
import { createAboutUsMottoStoreDefaultModel } from "./about-us-motto/about-us-motto.store";
import { createAboutUsVisionStoreDefaultModel } from "./about-us-vision/about-us-vision.store";
import { createAboutUsMissionStoreDefaultModel } from "./about-us-mission/about-us-mission.store";
import { createAboutUsWorkCultureStoreDefaultModel } from "./about-us-work-culture/about-us-work-culture.store";
import { createAboutUsFounderStoreDefaultModel } from "./about-us-founder/about-us-founder.store"
import { createAboutUsStructureStoreDefaultModel } from "./about-us-structure/about-us-structure.store";
import { createAboutUsAuthorityStoreDefaultModel } from "./about-us-authority/about-us-authority.store";
import { createAboutUsTransformationStoreDefaultModel } from "./about-us-transformation/about-us-transformation.store";

const aboutUsContentModels = {
  aboutUsProfile: createAboutUsProfileStoreDefaultModel(),
  aboutUsDuty: createAboutUsDutyStoreDefaultModel(),
  aboutUsMotto: createAboutUsMottoStoreDefaultModel(),
  aboutUsVision: createAboutUsVisionStoreDefaultModel(),
  aboutUsMission: createAboutUsMissionStoreDefaultModel(),
  aboutUsWorkCulture: createAboutUsWorkCultureStoreDefaultModel(),
  aboutUsFounder: createAboutUsFounderStoreDefaultModel(),
  aboutUsStructure: createAboutUsStructureStoreDefaultModel(),
  aboutUsAuthority: createAboutUsAuthorityStoreDefaultModel(),
  aboutUsTransformation: createAboutUsTransformationStoreDefaultModel()
}

export { aboutUsContentModels }